var render = function () {
  var _vm$currentRound, _vm$currentRound$answ, _vm$currentRound$answ2, _vm$currentRound2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    class: ("shift-for-capitals " + (_vm.isMobile ? 'tablet' : '')),
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('aside', [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Main image",
      "src": (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : (_vm$currentRound$answ = _vm$currentRound.answerImage) === null || _vm$currentRound$answ === void 0 ? void 0 : (_vm$currentRound$answ2 = _vm$currentRound$answ.image) === null || _vm$currentRound$answ2 === void 0 ? void 0 : _vm$currentRound$answ2.src
    }
  })])]), _c('text-display-list', {
    attrs: {
      "isMobileView": _vm.isMobile
    }
  }, [_c('li', {
    staticClass: "step"
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": (_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : _vm$currentRound2.answer,
      "roundId": _vm.progress.roundIndex,
      "text-step": 0
    }
  })], 1)])], 1)], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }